// extracted by mini-css-extract-plugin
export default {"view":"view__s6lZH","header":"header__yjW45"};